import React from "react";
import { Alert, Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import CrmExportConflicts from "./CrmExportConflicts";

export default function CrmExportPreview({ model }) {
  const counts = model.counts;
  return (
    <Box sx={{ overflowWrap: "anywhere" }}>
      <Typography sx={{ mb: 1 }}>Preview for HubSpot portal {model.portal_id}. Existing CRM values stay in place.</Typography>
      <Table size="small" aria-label="Planned CRM changes" sx={{ tableLayout: "fixed", "& th, & td": { px: { xs: 0.5, sm: 1.5 }, overflowWrap: "anywhere" } }}>
        <TableHead><TableRow><TableCell sx={{ width: "32%" }}>Records</TableCell><TableCell sx={{ width: "18%" }}>Create</TableCell><TableCell sx={{ width: "32%" }}>Fill empty fields</TableCell><TableCell sx={{ width: "18%" }}>Skip</TableCell></TableRow></TableHead>
        <TableBody>
          {["companies", "contacts"].map((type) => (
            <TableRow key={type}>
              <TableCell component="th" scope="row">{type === "companies" ? "Companies" : "Verified contacts"}</TableCell>
              <TableCell>{counts[`${type}_create`]}</TableCell><TableCell>{counts[`${type}_fill`]}</TableCell><TableCell>{counts[`${type}_skip`]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {model.companies_without_contacts > 0 && (
        <Alert severity="info" sx={{ mt: 2 }}>
          {model.companies_without_contacts} selected {model.companies_without_contacts === 1 ? "company has" : "companies have"} no verified contacts. These rows push companies only. Enrich with verified contacts to include contacts.
        </Alert>
      )}
      {model.unmatchable.length > 0 && <Alert severity="warning" sx={{ mt: 2 }}>No usable company domain for: {model.unmatchable.join(", ")}. These companies cannot be pushed.</Alert>}
      {counts.companies_duplicate_in_selection > 0 && <Typography sx={{ mt: 1 }}>{counts.companies_duplicate_in_selection} duplicate selections will be skipped.</Typography>}
      <CrmExportConflicts conflicts={model.conflicts} />
    </Box>
  );
}
